export default __webpack_public_path__ + "static/media/banner2en.0f5a95da.png";